import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32637246"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "home-main-box" }
const _hoisted_3 = { class: "home-TUIKit" }
const _hoisted_4 = { class: "setting" }
const _hoisted_5 = { class: "setting-main" }
const _hoisted_6 = { class: "userInfo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "setting-main-list" }
const _hoisted_9 = { class: "icon icon-message-selected" }
const _hoisted_10 = { class: "icon icon-message" }
const _hoisted_11 = { class: "icon icon-relation-selected" }
const _hoisted_12 = { class: "icon icon-relation" }
const _hoisted_13 = {
  key: 0,
  class: "setting-more"
}
const _hoisted_14 = { class: "showmore" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-setting" }, "设置", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-cut-box" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "show-cut" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑资料", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-cut-box" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "show-cut" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "home-TUIKit-main" }
const _hoisted_23 = { class: "chat" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("欢迎使用"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("维库电子市场网"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("阿库即时通讯")
], -1))
const _hoisted_25 = { class: "home-TUIKit-main" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat-default" }, null, -1))
const _hoisted_27 = { class: "compony" }
const _hoisted_28 = {
  key: 1,
  class: "home-h5-main"
}
const _hoisted_29 = { class: "message" }
const _hoisted_30 = { class: "home-h5-content" }
const _hoisted_31 = { class: "home-h5-main-header" }
const _hoisted_32 = { class: "home-h5-main-content" }
const _hoisted_33 = { class: "home-h5-content" }
const _hoisted_34 = { class: "home-h5-content home-h5-profile" }
const _hoisted_35 = { class: "home-h5-profile-footer" }
const _hoisted_36 = { class: "nav" }
const _hoisted_37 = { class: "nav-list" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: ""
}
const _hoisted_40 = { class: "dialog-footer" }
const _hoisted_41 = { class: "dialog_login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIProfile = _resolveComponent("TUIProfile")!
  const _component_TUISearch = _resolveComponent("TUISearch")!
  const _component_TUIConversation = _resolveComponent("TUIConversation")!
  const _component_TUIChat = _resolveComponent("TUIChat")!
  const _component_TUIContact = _resolveComponent("TUIContact")!
  const _component_compony_name = _resolveComponent("compony-name")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_IsLogin = _resolveComponent("IsLogin")!
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['home' + (_ctx.env.isH5 ? '-h5' : '')]),
      id: _ctx.env.isH5 ? '' : ''
    }, [
      (!_ctx.env.isH5)
        ? (_openBlock(), _createElementBlock("main", {
            key: 0,
            class: _normalizeClass(["home-main", [_ctx.menuStatus && 'home-main-open']])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("main", _hoisted_5, [
                    _createElementVNode("aside", _hoisted_6, [
                      _createElementVNode("img", {
                        class: "avatar",
                        src: 
                    _ctx.userInfo.avatar
                      ? _ctx.userInfo.avatar
                      : 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'
                  ,
                        onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("div", {
                        class: _normalizeClass(["userInfo-main", [_ctx.showProfile ? 'TUIProfile' : '']]),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChangeStatus && _ctx.handleChangeStatus(...args)), ["self"]))
                      }, [
                        _createElementVNode("main", null, [
                          _createVNode(_component_TUIProfile, {
                            view: _ctx.showProfile ? 'edit' : 'default',
                            onChangeStatus: _ctx.handleChangeStatus
                          }, null, 8, ["view", "onChangeStatus"])
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("ul", _hoisted_8, [
                      _createElementVNode("li", {
                        class: _normalizeClass(["setting-main-list-item", [_ctx.currentModel === 'message' && 'selected']]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectModel('message')))
                      }, [
                        _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                          [_vShow, _ctx.currentModel === 'message']
                        ]),
                        _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                          [_vShow, _ctx.currentModel !== 'message']
                        ])
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass(["setting-main-list-item", [_ctx.currentModel === 'group' && 'selected']]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectModel('group')))
                      }, [
                        _withDirectives(_createElementVNode("i", _hoisted_11, null, 512), [
                          [_vShow, _ctx.currentModel === 'group']
                        ]),
                        _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                          [_vShow, _ctx.currentModel !== 'group']
                        ])
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "setting-footer",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getProfile && _ctx.getProfile(...args)))
                  }, [
                    _createElementVNode("i", {
                      class: "icon icon-setting",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openShowMore && _ctx.openShowMore(...args)))
                    }),
                    (_ctx.showMore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _hoisted_16,
                            _createElementVNode("div", {
                              class: _normalizeClass(["show-profile", [_ctx.showProfile && 'more-selected']]),
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openShowProfile && _ctx.openShowProfile(...args))),
                              onMouseover: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeShowReceipt && _ctx.closeShowReceipt(...args)))
                            }, _hoisted_18, 34),
                            _hoisted_19,
                            _createElementVNode("div", {
                              class: "show-quit",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exitLogin && _ctx.exitLogin(...args))),
                              onMouseover: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeShowReceipt && _ctx.closeShowReceipt(...args)))
                            }, _hoisted_21, 32)
                          ]),
                          _createElementVNode("div", {
                            class: "moreMask",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openShowMore && _ctx.openShowMore(...args)), ["self"]))
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(_ctx.env?.isH5 ? 'conversation-h5' : 'conversation')
                  }, [
                    _createVNode(_component_TUISearch, { class: "search" }),
                    _createVNode(_component_TUIConversation, { onCurrent: _ctx.handleCurrentConversation }, null, 8, ["onCurrent"])
                  ], 2), [
                    [_vShow, !_ctx.env?.isH5 || _ctx.currentModel === 'conversation']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_TUIChat, { keyword: _ctx.keyword }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }, 8, ["keyword"])
                  ], 512), [
                    [_vShow, _ctx.currentModel === 'message']
                  ])
                ], 512), [
                  [_vShow, _ctx.currentModel === 'message']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createVNode(_component_TUIContact, null, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.currentModel === 'group']
                  ])
                ], 512), [
                  [_vShow, _ctx.currentModel === 'group']
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_compony_name, { allParams: _ctx.allParams }, null, 8, ["allParams"])
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.env.isH5)
        ? (_openBlock(), _createElementBlock("main", _hoisted_28, [
            _withDirectives(_createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("main", _hoisted_30, [
                _createElementVNode("header", _hoisted_31, [
                  _createVNode(_component_TUISearch)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_TUIConversation, { onCurrent: _ctx.handleCurrentConversation }, null, 8, ["onCurrent"])
                ])
              ], 512), [
                [_vShow, _ctx.currentModel === 'message']
              ]),
              _withDirectives(_createElementVNode("main", _hoisted_33, [
                _createVNode(_component_TUIContact)
              ], 512), [
                [_vShow, _ctx.currentModel === 'group']
              ]),
              _withDirectives(_createElementVNode("main", _hoisted_34, [
                _createVNode(_component_TUIProfile),
                _createElementVNode("footer", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exitLogin && _ctx.exitLogin(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.$t('退出登录')), 1)
                ])
              ], 512), [
                [_vShow, _ctx.currentModel === 'profile']
              ]),
              _createElementVNode("footer", _hoisted_36, [
                _createElementVNode("ul", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-list-item",
                      key: index,
                      onClick: ($event: any) => (_ctx.selectModel(item.name))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["icon", [
                  'icon-' +
                    (_ctx.currentModel === item.name
                      ? `${item.icon}-selected`
                      : `${item.icon}-real`),
                ]])
                      }, null, 2),
                      _createElementVNode("label", {
                        class: _normalizeClass([_ctx.currentModel === item.name && `selected`])
                      }, _toDisplayString(_ctx.$t(`${item.label}`)), 3)
                    ], 8, _hoisted_38))
                  }), 128))
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.currentConversationID]
            ]),
            _withDirectives(_createVNode(_component_TUIChat, {
              isSupportGroupReceipt: _ctx.isSupportGroupReceipt,
              keyword: _ctx.keyword
            }, null, 8, ["isSupportGroupReceipt", "keyword"]), [
              [_vShow, _ctx.currentConversationID]
            ]),
            (_ctx.env.isH5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.appPersonalDialogVisible,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.appPersonalDialogVisible) = $event)),
                    width: "90%",
                    "before-close": false,
                    "show-close": false,
                    top: "30vh",
                    class: "appPersonalDialog"
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("span", _hoisted_40, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.appPersonalDialogVisible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.appPersonalDialogVisible = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 去下载 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 您的聊天时长已用完 请下载芯视频APP聊天更方便哦 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_IsLogin, {
        loginParams: _ctx.loginParams,
        isH5: _ctx.env.isH5
      }, null, 8, ["loginParams", "isH5"]),
      _createVNode(_component_HelloWorld)
    ])
  ], 64))
}